// EN-4743. What a licence / state ID barcode read adds to the ID validation request.
//
// Same fields and format as the kiosk's buildBarcodeExtractionFields
// (visitly-kiosk-app/src/screens/IdCaptureScreen/index.js). Both photos are always
// sent as well; these fields are extra information for the backend, never a
// replacement for them.
import type { AamvaBarcode } from './aamva';
import { formatAamvaDate } from './idDates';
import type { IdExtractionFields } from '../../types/idValidation';

export const buildBarcodeExtractionFields = (barcode: AamvaBarcode | null): IdExtractionFields => {
  if (!barcode) return {};
  return {
    extractionSource: 'barcode',
    firstName: barcode.firstName,
    middleName: barcode.middleName,
    lastName: barcode.lastName,
    nameSuffix: barcode.nameSuffix,
    documentNumber: barcode.documentNumber,
    // YYYY-MM-DD, not the 8 bare digits the card stores.
    dateOfBirth: formatAamvaDate(barcode.dateOfBirth),
    issueDate: formatAamvaDate(barcode.issueDate),
    expiryDate: formatAamvaDate(barcode.expiryDate),
  };
};
